module.exports = __webpack_public_path__ + "static/media/WinduLogo.306a29d6.svg";